(ns teamoesterreich.admin-mode.data.userDocument
  (:require [teamoesterreich.ajax :as ajax]
            [goog.json :as json]
            [clojure.walk]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]))


(def DOC_TYPES {
                ""                      {:name "Unbekannt" :tipps "Unbekannt"}
                ;"firstAid-certificate"  {:name "EH-Zeugnis" :tipps "Prüfe Name, Zeugnisdatum "}
                "first-aid-certificate" {:name "EH-Zeugnis" :tipps "Prüfe Name, Zeugnisdatum "}
                "paramedic-certificate" {:name "RS Nachweis/Rezertifizierung" :tipps "Bitte prüfe ob ..."}
                "professionId"          {:name "Dienstausweis (Polizei,...)" :tipps "Bitte prüfe ob ..."}
                "doctorId"              {:name "Arztausweis" :tipps "Bitte prüfe ob ..."}
                "other-certificate"     {:name "Sonstiges Zeugnis" :tipps "Bitte prüfe ob ..."}
                "other"                 {:name "Sonstiges" :tipps "Bitte prüfe ob ..."}
                })




(defn >edit-document-field [document-uuid obj cb-fn]
  (ajax/patch> (str backend/BASE_URL "/user/document/" document-uuid)
               (ajax/serialize (merge {:userDocument-uuid document-uuid}
                                      obj))
               cb-fn))



